var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"top-page"},[_c('TopPaper'),_c('TopLetter'),_c('transition',[_c('TopHome')],1),_c('BaseFooter')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }